import { FC, useEffect } from 'react';

import { CloseCrossBtn } from '../../icons/close-cross-btn';

interface MeetChatImageLightboxProps {
  imageSrc: string | null;
  onClose: () => void;
}

export const MeetChatImageLightbox: FC<MeetChatImageLightboxProps> = ({ imageSrc, onClose }) => {
  useEffect(() => {
    if (!imageSrc) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [imageSrc, onClose]);

  if (!imageSrc) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center bg-black/85 p-2 pt-[max(8px,env(safe-area-inset-top,0px))] pb-[max(8px,env(safe-area-inset-bottom,0px))] sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Просмотр изображения"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-3 top-3 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white shadow-[0_2px_12px_rgba(0,0,0,0.25)] transition-opacity hover:opacity-90 sm:right-4 sm:top-4"
        aria-label="Закрыть"
      >
        <CloseCrossBtn width={20} height={20} />
      </button>

      <img
        src={imageSrc}
        alt="Изображение из чата"
        className="max-h-full max-w-full object-contain"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};
